import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from '../Link'
import PartnerImageArticle from './components/PartnerImageArticle'
import TypeImageArticle from './components/TypeImageArticle'
import LocalSymbol from '../../images/MapSouthtyrol'
import PlayCircle from '../../images/VideoPlayCircle'
import ImageWidescreen from '../ImageWidescreen'
import ResizeDetector from '../ResizeDetector'
import { useMediaQuery } from '../../modules/media-query'

const ImageLink = styled(Link)`
  display: block;
  position: relative;
  color: transparent;
  text-decoration: none;
`
const LocalImage = styled(LocalSymbol)`
  stroke-width: 5.6px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  height: ${(props) => (props.iconSize && props.iconSize <= 50 ? props.iconSize + 'px' : '50px')};
`
const WrapperLocalSymbol = styled.div`
  text-align: right;
  position: absolute;
  z-index: 1;
  right: 8px;
  top: 8px;
  height: max-content;
  width: max-content;

  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    top: 5px;
    right: 5px;
  }
`

const LeftCornerImage = styled.div`
  display: flex;
  align-items: flex-start;
  position: absolute;
  top: 8px;
  left: 8px;
  width: 70%;
  z-index: 1;

  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    top: 5px;
    left: 5px;
  }
`
const StyledPartnerItemArticle = styled(PartnerImageArticle)`
  height: ${(props) => (props.iconSize && props.iconSize <= 40 ? props.iconSize + 'px' : '40px')};
  margin-right: 5px;
`

const StyledPlayCircle = styled(PlayCircle)`
  height: ${(props) => (props.iconSize && props.iconSize <= 40 ? props.iconSize + 'px' : '40px')};
  margin-right: 5px;
`

/*
const Description = styled.div`
  position: absolute;
  bottom: 10px;
  left: 0;
  padding: 20px;
  padding-left: 10px;
  padding-bottom: 10px;
  z-index: -1;
`

const Headline = styled(TopLine)`
  ${LinkHeadLine0TopLine} {
    color: ${props => props.theme.color.textInvertedSecondary};
    font-size: ${props => props.theme.fontSize.base};
  }
`


const StyledTitle = styled(Title)`
  color: ${props => props.theme.color.textInverted};
  font-size: ${props => props.theme.fontSize.text};
  margin: 0;
`
*/

const Wrapper = styled.div`
  align-self: center;
  position: relative;
  cursor: pointer;
`

const Overlay = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ImageArticle = ({
  image,
  video,
  hasVideo,
  url,
  local,
  type,
  partner,
  headline,
  title,
  onClick,
  text,
  department,
  date,
  adsTargeting,
  content,
  location,
  eventLocation,
  breadcrumb,
  OverlayComponent,
  to,
  parentClass,
  noLazyLoading,
  ...props
}) => {
  /*
  playVideo(){
    if(this.props.video && this.props.video.imageUrl){
      this.setState({
        hoveringVideo: true,
      });
    }
  }
  resetVideo(){
    if(this.props.video && this.props.video.imageUrl){
      this.setState({
        hoveringVideo: false
      });
    }
  }
  */
  //const [videoSource, setVideoSource] = useState('original')
  const [iconSize, setIconSize] = useState(28)
  const mobileS = useMediaQuery('(max-width:450px)')
  const tabletS = useMediaQuery('(max-width:767px)')

  return (
    <Wrapper {...props} video={video}>
      <ResizeDetector
        onResize={(boundingClientRect) => {
          /*if (boundingClientRect.width < 400) {
            setVideoSource('preview')
          } else {
            setVideoSource('original')
          }*/
          if (boundingClientRect.width <= 210) {
            setIconSize(Math.round(boundingClientRect.width / 6.6))
          } else {
            if (mobileS) {
              setIconSize(Math.round(boundingClientRect.width / 13.5))
              if (
                parentClass &&
                (parentClass.includes('WidgetVideo') || parentClass.includes('DescriptionInVideoItemArticle'))
              ) {
                setIconSize(Math.round(boundingClientRect.width / 12))
              }
            } else {
              if (tabletS) {
                setIconSize(Math.round(boundingClientRect.width / 13.5))
              } else {
                setIconSize(Math.round(boundingClientRect.width / 11))
              }
            }
          }
        }}
      >
        <ImageLink to={to} onClick={onClick}>
          <Overlay>
            <OverlayComponent />
          </Overlay>
          {(partner || type || hasVideo) && (
            <LeftCornerImage>
              {hasVideo && <StyledPlayCircle iconSize={iconSize} />}
              {partner && <StyledPartnerItemArticle iconSize={iconSize} partner={partner} />}
              {type && <TypeImageArticle type={type && type} />}
            </LeftCornerImage>
          )}
          {local && (
            <WrapperLocalSymbol iconSize={iconSize}>
              <LocalImage /*video_source={videoSource} */ iconSize={iconSize} />
            </WrapperLocalSymbol>
          )}
          <ImageWidescreen image={image} title={title} noLazyLoading={noLazyLoading} />{' '}
          {/*TODO: add this if you want to show thumbnails hosted on jw cdn directly: video={video && video.type === 'jw' && video.imageUrl} */}
          {/*
            headline &&
            <Description>
              <Headline headline={headline && headline} />
              <StyledTitle>{title && title}</StyledTitle>
            </Description>
          */}
        </ImageLink>
      </ResizeDetector>
    </Wrapper>
  )
}

ImageArticle.defaultProps = {
  type: 'null', //TODO before Golive change to null if required by API from WeMo
  OverlayComponent: () => false,
}

ImageArticle.propTypes = {
  url: PropTypes.string,
  image: PropTypes.object,
  type: TypeImageArticle.propTypes.type,
  partner: PartnerImageArticle.propTypes.partner,
}

export default ImageArticle
